import styled from 'styled-components';
import { createGradientOrSolid } from 'utils';

export const StyledAddToHomePageButton = styled.button`
  display: flex;
  align-items: center;
  width: ${(props: any) => (props?.buttonImage ? '122px' : 'auto')};
  height: ${(props: any) => (props?.buttonImage ? '40px' : 'auto')};
  min-width: 100px;
  text-align: left;
  border-radius: ${(props: any) => (props?.buttonImage ? 0 : '36px')};
  border: ${(props: any) =>
    props?.buttonImage ? 0 : `2px solid ${props?.borderColor}`};
  background: ${(props: any) =>
    props?.buttonImage
      ? `url(${props?.buttonImage})`
      : createGradientOrSolid(props?.bgColor, true)};
  background-size: 100% 100%;
  box-shadow: ${(props: any) =>
    props?.buttonImage ? 0 : '0 4px 4px 0 rgba(0, 0, 0, 0.25)'};
  padding: ${(props: any) => (props?.buttonImage ? 0 : '4px 6px 4px 4px')};

  .description {
    font-family: var(--font-family), Arial;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
    color: ${(props: any) => props?.borderColor};
    padding: 0 4px;
  }
` as any;
